<template>
  <v-expansion-panels flat class="flat-expanssion-panel">
    <v-expansion-panel>
      <v-expansion-panel-header ripple color="grey lighten-4" class="accent--text">
        {{ $t("special-zoning-plan") }}
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-simple-table dense>
          <template v-slot:default>
            
            <tbody>
              <tr>
                <td>{{ $t("zpp-bravo-pri") }}</td>
                <td>
                  <ul class="list-plot-lists" v-if="isBravoPrisArray">
                    <li v-for="(item, index) in plotItem.BRAVO_PRIS" :key="index">{{ item }}</li>
                  </ul>
                  <span v-else>
                    <ul class="list-plot-lists">
                      <li>{{ plotItem.BRAVO_PRIS }}</li>
                    </ul>
                  </span>
                </td>
              </tr>
              <tr>
                <td>{{ $t("ueo-bravo-sec") }}</td>
                <td>
                  <ul class="list-plot-lists" v-if="isBravoSecArray">
                    <li v-for="(item, index) in plotItem.BRAVO_SECS" :key="index">{{ item }}</li>
                  </ul>
                  <span v-else>
                    <ul class="list-plot-lists">
                      <li>{{ plotItem.BRAVO_SECS }}</li>
                    </ul>
                  </span>
                </td>
              </tr>
              <tr>
                <td>{{ $t("usp-bravo-ter") }}</td>
                <td>
                  <ul class="list-plot-lists" v-if="isBravoTerArray">
                    <li v-for="(item, index) in plotItem.BRAVO_TERS" :key="index">{{ item }}</li>
                  </ul>
                  <span v-else>
                    <ul class="list-plot-lists">
                      <li>{{ plotItem.BRAVO_TERS }}</li>
                    </ul>
                  </span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script lang="ts">
import {Component, Prop, Vue} from "vue-property-decorator"

@Component({
  components: {},
})
export default class ViewPlotDetails300 extends Vue {
  @Prop()
  plotItem

  get isBravoPrisArray() {
    return Array.isArray(this.plotItem.BRAVO_PRIS)
  }
  get isBravoSecArray() {
    return Array.isArray(this.plotItem.BRAVO_SECS)
  }
  get isBravoTerArray() {
    return Array.isArray(this.plotItem.BRAVO_TERS)
  }
}
</script>
